import React, { useRef } from "react";
import { 
    Box, Button, Dialog, DialogContent, Grid, Slide, 
    Typography, IconButton, useTheme, Avatar, Divider 
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faTimes, faStore } from "@fortawesome/free-solid-svg-icons";
import QRCode from "react-qr-code";
import { toPng } from 'html-to-image';
import { imagesURL } from "../../../apiRoutes/apiBase";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function DonwloadableQR({ open, coupon, handleClose }) {
    const theme = useTheme();
    const ticketRef = useRef(null);

    const downloadQRCode = async () => {
        if (ticketRef.current) {
            try {
                const dataUrl = await toPng(ticketRef.current, { backgroundColor: '#fff' }); // Asegura fondo blanco
                const link = document.createElement('a');
                link.href = dataUrl;
                link.download = `Cupon-${coupon.title}.png`;
                link.click();
            } catch (err) {
                console.error("Error descargando imagen", err);
            }
        }
    };

    if (!coupon) return null;

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            onClose={handleClose}
            maxWidth='xs'
            fullWidth
            PaperProps={{
                sx: {
                    bgcolor: 'transparent', // Fondo transparente para ver el ticket flotando
                    boxShadow: 'none',
                    overflow: 'visible' // Para que el botón de cerrar salga si queremos
                }
            }}
        >
            {/* Botón Cerrar Flotante */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                <IconButton onClick={handleClose} sx={{ color: 'white', bgcolor: 'rgba(0,0,0,0.5)', '&:hover': { bgcolor: 'rgba(0,0,0,0.8)' } }}>
                    <FontAwesomeIcon icon={faTimes} />
                </IconButton>
            </Box>

            {/* CONTENEDOR DEL TICKET (Referencia para descarga) */}
            <Box ref={ticketRef} sx={{ bgcolor: 'transparent' }}> 
                
                {/* PARTE SUPERIOR (INFO) */}
                <Box sx={{ 
                    bgcolor: '#fff', 
                    borderRadius: '16px 16px 0 0', 
                    p: 3, 
                    position: 'relative',
                    textAlign: 'center'
                }}>
                    <Avatar 
                        src={imagesURL + 'empresas/' + coupon.merchant_imagen} 
                        sx={{ 
                            width: 70, height: 70, 
                            border: '4px solid #fff', 
                            boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                            margin: '0 auto',
                            mb: 2,
                            bgcolor: theme.palette.grey[100]
                        }}
                    >
                        <FontAwesomeIcon icon={faStore} color="#ccc"/>
                    </Avatar>

                    <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 1 }}>
                        CUPÓN DE DESCUENTO
                    </Typography>
                    
                    <Typography variant="h5" fontWeight="900" sx={{ mt: 1, color: theme.palette.primary.main }}>
                        {coupon.amount ? `$${coupon.amount}` : ''} {coupon.title}
                    </Typography>
                    
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1, px: 2 }}>
                        {coupon.description}
                    </Typography>

                    {/* Info de Fechas */}
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'space-between', bgcolor: '#f9f9f9', p: 1.5, borderRadius: 2 }}>
                        <Box>
                            <Typography variant="caption" color="text.disabled">EMISIÓN</Typography>
                            <Typography variant="body2" fontWeight="bold">{coupon.start_date}</Typography>
                        </Box>
                        <Box textAlign="right">
                            <Typography variant="caption" color="text.disabled">EXPIRA</Typography>
                            <Typography variant="body2" fontWeight="bold" color="error.main">{coupon.end_date}</Typography>
                        </Box>
                    </Box>
                </Box>

                {/* LINEA DE CORTE (Dashed) */}
                <Box sx={{ 
                    position: 'relative', 
                    height: 20, 
                    bgcolor: '#fff', 
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    {/* Muesca Izquierda */}
                    <Box sx={{ 
                        width: 20, height: 20, borderRadius: '50%', 
                        bgcolor: 'rgba(0,0,0,0.5)', // Color del backdrop del modal para que parezca transparente
                        position: 'absolute', left: -10 
                    }} />
                    
                    {/* Línea Punteada */}
                    <Box sx={{ 
                        width: '100%', borderBottom: '2px dashed #ddd', 
                        mx: 2.5 
                    }} />

                    {/* Muesca Derecha */}
                    <Box sx={{ 
                        width: 20, height: 20, borderRadius: '50%', 
                        bgcolor: 'rgba(0,0,0,0.5)', 
                        position: 'absolute', right: -10 
                    }} />
                </Box>

                {/* PARTE INFERIOR (QR) */}
                <Box sx={{ 
                    bgcolor: '#fff', 
                    borderRadius: '0 0 16px 16px', 
                    p: 4, 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center' 
                }}>
                    <Typography variant="body2" fontWeight="bold" sx={{ mb: 2, color: 'text.primary' }}>
                        Escanea para canjear
                    </Typography>

                    <Box sx={{ p: 2, border: '2px solid #eee', borderRadius: 2 }}>
                        <QRCode value={coupon.uuid} size={160} />
                    </Box>

                    <Typography variant="caption" sx={{ mt: 2, color: 'text.secondary', fontFamily: 'monospace' }}>
                        ID: {coupon.uuid.substring(0, 18)}...
                    </Typography>
                </Box>
            </Box>

            {/* BOTONES DE ACCIÓN */}
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                <Button 
                    variant="contained" 
                    color="primary"
                    startIcon={<FontAwesomeIcon icon={faDownload} />}
                    onClick={downloadQRCode}
                    sx={{ borderRadius: 50, px: 4, fontWeight: 'bold' }}
                >
                    Guardar Imagen
                </Button>
            </Box>
        </Dialog>
    );
}